module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-bar-graph-f01bfd79.svg";